// extracted by mini-css-extract-plugin
module.exports = {"userCard":"UserPendingCard__userCard--27v9H"};